import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getOfferingHTML       : ["payload"],
  generateOfferingPDF   : ["payload"],
  setPdfGeneratedBanner : ["show"]
}, { prefix: "admin_offering" });

export { Types, Creators };
